export default __webpack_public_path__ + "static/media/639.6c1eaa97.gif";